
import React from "react";
import fields from "../../json/HolidayFields.json";
import FormInput from "Common/Custom/FormInput";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const EditHolidayForm = ({
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
}) => {
    const { formdata } = fields;

    const renderField = (field) => {
        if (field.type === "date") {
            return (
                <FormDatePicker
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                    mode="date"
                    required={field.required}
                />
            );
        }
        return (
            <FormInput
                key={field.name}
                field={field}
                value={values[field.name]}
                handleChange={handleChange}
                error={errors[field.name]}
            />
        );
    }

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Edit Holiday</HeadingOne>
        }>
            {formdata.map((field) => renderField(field))}

            <FormSubmitButton
                label="Update Holiday"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditHolidayForm;
